import {
  Button,
  InputAdornment,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as AlertIcon } from "../Icons/ErrorAlert.svg";
import CREATE from "../Icons/create.png";
import {
  StyledPrimaryTypography,
  StyledSecondaryTypography,
  StyledErrorTypography,
  StyledTypography,
} from "../Theme";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  verifyEmail,
  setLoginSliceToNull,
  setVerifyEmailStatusToNull
} from "../Redux/Feature/Login/loginSlice";
import { ReactComponent as BackArrow } from "../Icons/BackArrow.svg";
import { showToast } from "../CommonComponents/Toaster";

const SignUp = ({ email, setEmail, setDisplayScreen }) => {
  const dispatch = useDispatch();
  const { loginStatus, verifyEmailStatus } = useSelector(
    (state) => state.Login
  );
  console.log(verifyEmailStatus)
  const [errorText, setErrorText] = useState("");
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    if (verifyEmailStatus !== null) {
      setLoadingBtn(false);
      if (verifyEmailStatus.success === true) {
        setDisplayScreen("otp");
        dispatch(setLoginSliceToNull());
      } else if (
        !verifyEmailStatus.success &&
        verifyEmailStatus.error === "Invalid User"
      ) {
        setErrorText(verifyEmailStatus.error);
      } else {
        console.log("called")
        setErrorText(verifyEmailStatus?.detail, "error");
        dispatch(setVerifyEmailStatusToNull())
      }
    }
  }, [verifyEmailStatus]);

  const handleEmail = (e) => {
    let { value } = e.target;
    setEmail(value);
    setErrorText("");
  };
  const handleSingUp = () => {
    let isError = validateEmail();
    if (!isError) {
      setLoadingBtn(true);
      dispatch(verifyEmail({ email }));
    }
  };

  const validateEmail = () => {
    let isError = false;
    if (email === "") {
      setErrorText("Error! No input detected.");
      isError = true;
    } else if (emailRegex.test(email) === false) {
      setErrorText("Enter valid email");
      isError = true;
    }
    return isError;
  };
  const handleBack = () => {
    setDisplayScreen("");
    setEmail("");
  };
  return (
    <>
      {/* <BackArrow onClick={handleBack} style={{ cursor: "pointer" }} /> */}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box component={"img"} src={CREATE} alt="create" sx={{width:300, height:70, cursor:'pointer'}}/>
      </Box>
      <StyledPrimaryTypography style={{ marginTop: "15px" }}>
        Sign Up{" "}
      </StyledPrimaryTypography>
      <StyledSecondaryTypography>
        Register for a CREATE account
      </StyledSecondaryTypography>
      
      <TextField
        value={email}
        placeholder="Email"
        onChange={handleEmail}
        inputProps={{ maxLength: 125 }}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {errorText !== "" && <AlertIcon />}
            </InputAdornment>
          ),
        }}
        sx={{
          mt: 3,
          mb: 2,
          "& .MuiInputBase-root": {
            color: errorText === "" ? "#111927" : "#912018",
          },
          backgroundColor: errorText === "" ? "#F9FAFB" : "#FEE4E2",
        }}
      />
      {errorText != "" && (
        <StyledErrorTypography>{errorText}</StyledErrorTypography>
      )}
      <Button
        disabled={loadingBtn}
        onClick={handleSingUp}
        fullWidth
        variant="contained"
        sx={{ my: 2 }}
      >
        {" "}
        {loadingBtn ? <CircularProgress size={25} /> : "Sign Up"}
      </Button>
      <StyledTypography style={{display : 'flex', justifyContent : 'center'}}>Already have a CREATE account? <span style={{ cursor: "pointer", color: "#800000", marginLeft : '5px' }} onClick={() => setDisplayScreen("login")}>Log In</span></StyledTypography>
      <Box sx={{mt : 2, display :'flex', justifyContent : 'center', alignItems : 'center', gap : 2}}>
        <StyledSecondaryTypography style={{color : 'gray'}}>
          Terms of Service
      </StyledSecondaryTypography>
      <StyledSecondaryTypography style={{color : 'gray'}}>
        |
      </StyledSecondaryTypography>
      <StyledSecondaryTypography style={{color : 'gray'}}>
        Privacy Policy
      </StyledSecondaryTypography>
      </Box>
    </>
  );
};

export default SignUp;
